<template>
  <div class="content order-list list report-list">
    <div class="row">
      <div class="col-sm-12">
        <el-card>
          <h4 style="color: #3b291d">Order List</h4>
          <!-- Start search part -->
          <div class="row">
            <div class="col-sm-5">
              <base-input label="Campaign Date Range" class="range-picker">
                <el-date-picker
                  type="daterange"
                  placeholder="Campaign Date Range"
                  v-model="searchKey.campaignDate"
                  @change="searchDateChange"
                  value-format="YYYY-MM-DD"
                  format="DD/MM/YYYY"
                >
                </el-date-picker>
              </base-input>
            </div>

            <div class="col-sm-3">
              <base-input
                placeholder=""
                label="Salesman"
                v-model="searchKey.salesmanSearch"
              >
                <el-select
                  clearable
                  @blur="selectBlur"
                  v-model="searchKey.salesmanSearch"
                  class="select-primary"
                  size="large"
                  filterable
                  style="width: 100%"
                  placeholder="Salesman"
                >
                  <el-option
                    class="select-primary"
                    v-for="item in SalesList"
                    :key="item"
                    :label="item"
                    :value="item"
                  >
                  </el-option>
                </el-select>
              </base-input>
            </div>

            <div class="col-sm-2">
              <base-input placeholder="" label="Site Name / Code" type="search">
                <el-input
                  clearable
                  style="
                    border: 1px solid hsl(0, 0%, 5%);
                    border-radius: 5px;
                    --el-input-focus-border-color: #f0f3f7;
                    margin-top: -2px;
                  "
                  v-model="searchKey.siteNameCode"
                >
                </el-input>
              </base-input>
            </div>

            <base-input label="Unit" v-model="searchKey.unit">
              <el-select
                v-model="searchKey.unit"
                class="select-primary"
                filterable
                size="large"
                placeholder="Unit"
                disabled
              >
                <el-option label="All" value="All"> </el-option>
                <el-option
                  v-for="item in UnitOption"
                  :label="item.alias"
                  :value="item.alias"
                  :key="item"
                >
                </el-option>
              </el-select>
            </base-input>
          </div>
          <div class="row">
            <div class="col-sm-5">
              <base-input
                placeholder=""
                label="Contracting Party / Advertiser"
                style="margin-top: 4px"
                v-model="searchKey.contractPartOrAdvertiser"
              >
                <el-select
                  clearable
                  @blur="selectBlurAdvertiser"
                  v-model="searchKey.contractPartOrAdvertiser"
                  class="select-primary"
                  size="large"
                  filterable
                  style="width: 100%"
                  placeholder="Contracting Party / Advertiser"
                >
                  <el-option
                    class="select-primary"
                    v-for="item in AdvertiserOptionals"
                    :key="item"
                    :label="item"
                    :value="item"
                  >
                  </el-option>
                </el-select>
              </base-input>
            </div>
            <div class="col-sm-3">
              <base-input placeholder="" label="Order No. / Contract No."
                ><el-input
                  clearable
                  style="
                    border: 1px solid hsl(0, 0%, 5%);
                    border-radius: 5px;
                    --el-input-focus-border-color: #f0f3f7;
                    margin-top: 4px;
                  "
                  v-model="searchKey.orderOrContractNo"
                >
                </el-input>
              </base-input>
            </div>
            <div class="col-sm-2">
              <base-input
                placeholder=""
                label="Product / Category"
                type="search"
              >
                <el-input
                  clearable
                  style="
                    border: 1px solid hsl(0, 0%, 5%);
                    border-radius: 5px;
                    --el-input-focus-border-color: #f0f3f7;
                    margin-top: 4px;
                  "
                  v-model="searchKey.productSearch"
                >
                </el-input>
              </base-input>
            </div>
            <div class="col-sm-2">
              <div style="column-gap: 5px; top: 30px"></div>
              <div class="row">
                <div
                  style="
                    column-gap: 5px;
                    text-align: right;
                    position: absolute;
                    bottom: 5px;
                  "
                >
                  <base-button
                    type="primary"
                    @click="search"
                    style="width: 100px"
                    >Search</base-button
                  >
                  <base-button
                    type="primary"
                    @click="reset"
                    style="width: 100px"
                    >Reset</base-button
                  >
                </div>
              </div>
            </div>
          </div>
          <!-- end Search part-->
          <div class="row" style="margin-top: 20px">
            <div class="col-sm-12" style="display: flex">
              <div style="line-height: 32px; cursor: pointer">
                <base-button
                  type="primary"
                  @click="NewOrder"
                  v-if="
                    OrderListFunctions.find((t) => t.alias == 'NewOrder')
                      ?.enable
                  "
                  :disabled="
                    OrderListFunctions.find((t) => t.alias == 'NewOrder')
                      ?.disable
                  "
                >
                  <el-icon style="margin-right: 6px">
                    <Plus />
                  </el-icon>
                  New Order</base-button
                >
                <!-- <span class="add-button"> + </span>
                New Order -->
              </div>
              <span
                style="
                  margin-left: auto;
                  line-height: 32px;
                  padding-right: 20px;
                "
              >
                Total No. of Record: {{ reportPagination.total }}
                <base-pagination
                  class="pagination-no-border"
                  v-model="reportPagination.pageIndex"
                  :total="reportPagination.total"
                  :pagesToDisplay="10"
                  style="float: right"
                  :value="reportPagination.pageIndex"
                  @changePage="ChangePageSearch"
                  @nextPage="ChangePageSearch"
                >
                </base-pagination>
              </span>
            </div>
          </div>

          <div class="row">
            <div class="col-sm-12">
              <el-table
                :data="orderlist"
                style="width: 100%"
                border
                header-row-class-name="header-row"
                class="order-report order-list-report is-sort is-sort-sm"
                @filter-change="filterChange"
                table-layout="auto"
                cell-class-name="report-cell"
                @sort-change="sortChange"
              >
                <el-table-column
                  prop="unit"
                  width="70"
                  label="Unit"
                  class-name="unit"
                >
                </el-table-column>
                <el-table-column
                  prop="orderNumber"
                  width="160"
                  label="Order No."
                  class-name="orderno has-sort order-report-sort"
                  sortable="custom"
                  :sort-orders="null"
                >
                  <template #header>
                    <div style="order: 1">Order No.</div>
                    <div style="order: 3" class="search">
                      <table-column-filter
                        filterKey="orderNumber"
                        v-model="searchKey.orderNo"
                        @click="columnFilterClick"
                        @close="activeFilterLabel = ''"
                        :visible="activeFilterLabel === 'orderNumber'"
                        @confirm="search"
                        virtual-triggering
                      />
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="contractingParty"
                  label="Contracting Party"
                  class-name="contractparty"
                >
                  <template #header>
                    <div style="order: 1">Contracting Party</div>
                    <div style="order: 2" class="search">
                      <table-column-filter
                        filterKey="contractingParty"
                        v-model="searchKey.contractingParty"
                        @click="columnFilterClick"
                        @close="activeFilterLabel = ''"
                        :visible="activeFilterLabel === 'contractingParty'"
                        @confirm="search"
                        virtual-triggering
                      />
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="contractNumber"
                  label="Contract No."
                  width="220"
                  class-name="contractno  has-sort order-report-sort"
                  sortable="custom"
                  :sort-orders="null"
                  @sort-change="sortChange"
                >
                  <template #header>
                    <div style="order: 1">Contract No.</div>
                    <div style="order: 3" class="search">
                      <table-column-filter
                        filterKey="contractNo"
                        v-model="searchKey.contractNo"
                        @click="columnFilterClick"
                        @close="activeFilterLabel = ''"
                        :visible="activeFilterLabel === 'contractNo'"
                        @confirm="search"
                        virtual-triggering
                      />
                    </div>
                  </template>
                  <template #default="scope">
                    <div
                      v-for="seq in (scope.row.contractNumber || '').split(',')"
                      :key="seq"
                    >
                      <span v-if="seq !== ''"> {{ seq }}</span>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="advertiser"
                  label="Advertiser"
                  class-name="advertiser"
                >
                  <template #header>
                    <div style="order: 1">Advertiser</div>
                    <div style="order: 3" class="search">
                      <table-column-filter
                        filterKey="advertiser"
                        v-model="searchKey.advertiser"
                        @click="columnFilterClick"
                        @close="activeFilterLabel = ''"
                        :visible="activeFilterLabel === 'advertiser'"
                        @confirm="search"
                        virtual-triggering
                      />
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="product"
                  label="Product"
                  class-name="product"
                >
                  <template #header>
                    <div style="order: 1">Product</div>
                    <div style="order: 3" class="search">
                      <table-column-filter
                        filterKey="product"
                        v-model="searchKey.product"
                        @click="columnFilterClick"
                        @close="activeFilterLabel = ''"
                        :visible="activeFilterLabel === 'product'"
                        @confirm="search"
                        virtual-triggering
                      />
                    </div> </template
                ></el-table-column>
                <el-table-column
                  prop="startDate"
                  label="Campaign Start"
                  width="180"
                  :formatter="formatterCellDate"
                  class-name="campaignstart  has-sort order-report-sort"
                  sortable="custom"
                  :sort-orders="null"
                >
                  <template #header>
                    <div style="order: 1">Campaign Start</div>
                    <div style="order: 3" class="search">
                      <table-column-filter
                        filterKey="campaignStart2"
                        @click="columnFilterClick"
                        inputType="date"
                        @close="activeFilterLabel = ''"
                        v-model="searchKey.campaignStart2"
                        :visible="activeFilterLabel === 'campaignStart2'"
                        @confirm="search"
                        virtual-triggering
                      />
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="endDate"
                  label="Campaign End"
                  width="180"
                  :formatter="formatterCellDate"
                  class-name="campaignend  has-sort order-report-sort"
                  sortable="custom"
                  :sort-orders="null"
                >
                  <template #header>
                    <div style="order: 1">Campaign End</div>
                    <div style="order: 3" class="search">
                      <table-column-filter
                        filterKey="campaignEnd2"
                        @click="columnFilterClick"
                        inputType="date"
                        @close="activeFilterLabel = ''"
                        v-model="searchKey.campaignEnd2"
                        :visible="activeFilterLabel === 'campaignEnd2'"
                        @confirm="search"
                        virtual-triggering
                      />
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="totalAmount"
                  :formatter="formatterCellMoney"
                  label="Total Amount"
                  align="right"
                  width="210"
                  class-name="totalamount"
                />
                <el-table-column
                  prop="salesman"
                  label="Salesman"
                  width="150"
                  class-name="salesman"
                >
                  <template #header>
                    <div style="order: 1">Salesman</div>
                    <div style="order: 3" class="search">
                      <table-column-filter
                        filterKey="salesman"
                        v-model="searchKey.salesman"
                        @click="columnFilterClick"
                        @close="activeFilterLabel = ''"
                        :visible="activeFilterLabel === 'salesman'"
                        @confirm="search"
                        virtual-triggering
                      />
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="createDate"
                  label="Created Date"
                  width="170"
                  :formatter="formatterCellDateTime"
                  class-name="createdate has-sort order-report-sort"
                  sortable="custom"
                  :sort-orders="null"
                  @sort-change="sortChange"
                >
                  <template #header>
                    <div style="order: 1">Created Date</div>
                    <div style="order: 3" class="search">
                      <table-column-filter
                        filterKey="createDate"
                        v-model="searchKey.createDate"
                        @click="columnFilterClick"
                        @close="activeFilterLabel = ''"
                        :visible="activeFilterLabel === 'createDate'"
                        @confirm="search"
                        virtual-triggering
                      />
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="status"
                  label="Status"
                  width="110"
                  :filters="ColumnFilterOptionals"
                  filter-placement="bottom-end"
                  column-key="Status"
                  class-name="status"
                >
                </el-table-column>
                <el-table-column
                  prop=""
                  label="Action"
                  class-name="action"
                  width="100"
                >
                  <template #default="scope">
                    <el-button type="text" @click="openpage('view', scope.row)"
                      ><el-icon :size="18" style="color: #303133">
                        <Search /> </el-icon
                    ></el-button>
                    <el-button
                      type="text"
                      @click="openpage('edit', scope.row)"
                      v-if="scope.row.isWrite"
                      style="color: #303133"
                    >
                      <el-icon :size="18"> <Edit /> </el-icon
                    ></el-button>
                  </template>
                </el-table-column>
              </el-table>
              <div></div>
            </div>
          </div>
        </el-card>
      </div>
    </div>
  </div>
</template>

<script setup>
import './css/index.css';
import { watch, ref, reactive, onBeforeMount } from 'vue';
import baseInput from '@/components/newUI/Inputs/BaseInput';
import baseButton from '@/components/newUI/BaseButton';
import basePagination from '@/components/newUI/BasePagination';
import tableColumnFilter from '@/components/tablecolumn/tableColumnFilter.vue';
import { useOrderStore } from '@/store/order.js';
import { routeParamsStore } from '@/store/routeParams';
// router
import router from '@/router';
import booknet from '@/network/booknet';

// api
import basicapi from '@/network/optional';

// icon
import { Edit, Search, Plus } from '@element-plus/icons-vue';

// tool
import {
  formatterCellDate,
  formatterCellDateTime,
  formatterCellMoney,
} from '@/assets/js/formatter';
import { ElMessage } from 'element-plus';

//const result = ref("");
//变更分页
const ChangePageSearch = async (data) => {
  reportPagination.pageIndex = data;
  search();
};
const useParam = routeParamsStore();

const UnitOption = ref([]);

const searchKey = reactive({
  unit: 'BB',
  salesman: '',
  advertiser: '',
  bookingNo: '',
  product: '',
  orderNo: '',
  startDate: '0001-01-01',
  endDate: '0001-01-01',
  campaignDate: null,
  productSearch: '',
});

const activeFilterLabel = ref('');

const ColumnFilterOptionals = ref([]);
const SalesList = ref([]);
const AdvertiserOptionals = ref([]);
const reportPagination = reactive({
  pageIndex: 1,
  pageSize: 10,
});
// const bEnableCreate = ref(false);
// const enableCreateMessage = ref('');

var OrderListFunctions = ref([]);

// #region datas
const orderlist = ref([]);
// #endregion

const NewOrder = async () => {
  //设置参数传值
  useParam.orderParams = {
    OrderNo: '',
    mode: 'edit',
    id: 0,
  };
  // 更新Order Unit
  var Unit = {
    id: UnitOption.value.find((t) => t.alias == searchKey.unit)?.id,
    alias: 'BB',
  };
  useOrderStore().setUnit(Unit);
  // 更新页面参数
  useParam.setPageParam({
    key: '',
    mode: 'edit',
  });

  window.open('order?OrderNo=');
  //if (result.value.statusText === "OK") {
  // router.replace({
  //   name: 'order',
  //   query: {
  //     OrderNo: '',
  //   },
  //   params: {
  //     mode: 'edit',
  //     id: 0,
  //   },
  // });
  //}
};
// 获取输入的值
const selectBlur = (e) => {
  searchKey.salesmanSearch = e.target.value;
};
//获取输入的值
const selectBlurAdvertiser = (e) => {
  searchKey.contractPartOrAdvertiser = e.target.value;
};
onBeforeMount(async () => {
  useParam.home = '';
  var OrderPermission = await booknet
    .getOrderBase('BB')
    .then((res) => res.data);
  if (OrderPermission?.bPageVisit) {
    OrderListFunctions.value = OrderPermission?.orderListFunctions || [];

    //bEnableCreate.value = OrderPermission.bEnableCreateOrder;
    //enableCreateMessage.value = OrderPermission.enableCreateMessage;

    UnitOption.value = OrderPermission.unitOptions;

    const optionals = await basicapi
      .getOrderStatusOptionals()
      .then((res) => res);
    //if (optionals.statusText === 'OK') {
    if (optionals.status === 200) {
      ColumnFilterOptionals.value = optionals.data.map((t) => {
        return { text: t.label, value: t.value };
      });
    }
    // 读取基本的Option
    const optionals1 = await booknet.GetOrderSalesmanList().then((res) => res);
    // 销售员选项
    SalesList.value = optionals1.data;

    // ContractingParty
    var result = await booknet
      .GetOrderContractingPartyList()
      .then((res) => res);
    AdvertiserOptionals.value = result.data;

    await search();
  }
});

// event: Edit
const openpage = (type, order) => {
  //设置参数传值
  useParam.orderParams = {
    OrderNo: order.orderNumber,
    mode: type,
    id: order.id,
  };

  // useParam.home = '';
  // 更新页面参数
  useParam.setPageParam({
    key: order.orderNumber,
    mode: type,
  });

  //router.push("order?OrderNo=" + orderno);
  window.open('order?OrderNo=' + order.orderNumber);
  // router.push({
  //   name: 'order',
  //   query: {
  //     OrderNo: order.orderNumber,
  //   },
  //   params: {
  //     mode: type,
  //     id: order.id,
  //   },
  // });
};

// event: Search
const search = async () => {
  activeFilterLabel.value = '';

  searchDateChange();

  reportPagination.searchConditions = searchKey;

  const search_res = await booknet
    .getOrderList(reportPagination)
    .then((res) => res);
  reportPagination.total = search_res.data.total;
  orderlist.value = search_res.data.orderList;
};
//重置筛选条件
const reset = async () => {
  //清空对象
  Object.keys(searchKey).map((key) => {
    delete searchKey[key];
  });
  searchKey.unit = UnitOption.value?.[0].en;
  searchKey.campaignDate = null;
  reportPagination.pageIndex = 1;
  search();
};
// change: 查询日期分拆
const searchDateChange = () => {
  if (searchKey.campaignDate === null) {
    searchKey.startDate = '0001-01-01';
    searchKey.endDate = '0001-01-01';
  } else {
    searchKey.startDate = searchKey.campaignDate[0];
    searchKey.endDate = searchKey.campaignDate[1];
  }
};

// filter: 筛选状态
// const filterStatus = (value, column, row) => {
//   console.log("status", value, column, row);

//   return column["status"] === value;
// };

const filterChange = async (filters) => {
  searchKey.status = filters.Status;
  await search();
};

const sortChange = async (column, prop, order) => {
  reportPagination.orderBy = column.order;
  reportPagination.orderByColumn = column.prop;

  await search();
};
const columnFilterClick = (key) => {
  activeFilterLabel.value = key;
};
</script>

<style>
.order-list-report table.el-table__body th .cell {
  display: flex;
  align-items: center;
  padding-top: 6px;
  padding-bottom: 6px;
}
</style>
<style scoped>
.orderlist {
  font-size: 13px;
}

.searchs {
  width: 1213px;
  display: flex;
  flex-wrap: wrap;
  padding: 5px 0;
}

.searchs-item {
  line-height: 2.1rem;
  display: flex;
}

.searchs-item .searchs-item-control {
  padding: 0 50px 0 10px;
}

span.filter-cell {
  line-height: 2rem;
}

.filter-cell-title {
  padding: 5px 0;
}

.filter-cell-icon {
  position: absolute;
  top: 0;
  right: 12px;
}

.filter-cell-control {
  min-width: 230px;
}

.el-pagination {
  float: right;
}
</style>
<style>
.orderlist .report-cell .cell {
  word-break: break-word;
}

.range-picker .el-date-editor {
  border: 0px !important;
}

.content.order-list .form-group.has-label .el-input__inner {
  position: relative;
  top: 5px;
}
.order-report .search {
  flex-grow: 1;
  text-align: right;
}
</style>
